import { SectionValidationCheckModel } from "./section-validation-check.model";

export class SectionModel {
    PullType?: string;    
    Length?: number;
    radius?: number;
    angle?: number;    
    bendchord?: number;
    bendsagitta?: number;
    benddirection?: number;    
    machineeffort?: number;
    pushpullmachine?: boolean;
    pulldirectionud?: number;
    Tension?: number;
    Swpb?: number;
    Result?: string;
    notes?: string;
    RowId: number;

    // Checks?: SectionValidationCheckModel[];
}

export enum ShareStep {
  GetLink = 1,
  GeneratingLink = 2,
  EmailLink = 3,
  CopyLink = 4,
  Success = 5
}
